import { ArrowLeft } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';

import { roleLabels, type Role } from '../../content/registry';

const validRoles = new Set<string>(['manager', 'member', 'admin']);

interface ArticlePageProps {
  title: string;
  children: React.ReactNode;
}

export function ArticlePage({ title, children }: ArticlePageProps) {
  const [searchParams] = useSearchParams();
  const from = searchParams.get('from');
  const isRoleBack = from && validRoles.has(from);

  const backTo = isRoleBack ? `/${from}` : '/';
  const backLabel = isRoleBack
    ? `${roleLabels[from as Role]}向けガイド`
    : 'TONOME Core ユーザーガイド';

  return (
    <div>
      <Link
        to={backTo}
        className='mb-4 inline-flex items-center gap-1 text-primary hover:underline'
      >
        <ArrowLeft size={16} /> {backLabel}
      </Link>
      <div className='mt-4 rounded-lg border border-border bg-white p-8'>
        <h1 className='mb-6 text-2xl font-bold text-text'>{title}</h1>
        {children}
      </div>
    </div>
  );
}
